module.exports = __webpack_public_path__ + "img/干果标题.2264445a.png";